import {
  endOfDay,
  endOfMinute,
  isAfter,
  isBefore,
  isValid,
  parse,
  set,
} from 'date-fns'
import { orderBy } from 'lodash'

const DATE_FORMATS = ['dd.MM.yyyy', 'dd-MM-yyyy']
const TIME_FORMAT = 'HH:mm'

const parseBannerDate = (value) => {
  if (!value) return undefined

  for (const dateFormat of DATE_FORMATS) {
    const parsedDate = parse(value, dateFormat, new Date())

    if (isValid(parsedDate)) return parsedDate
  }

  return null
}

const parseBannerTime = (value) => {
  if (!value) return undefined

  const parsedTime = parse(value, TIME_FORMAT, new Date())

  return isValid(parsedTime) ? parsedTime : null
}

const getBannerDateTime = (dateValue, timeValue, isEndDate = false) => {
  const date = parseBannerDate(dateValue)

  if (date === undefined) return undefined
  if (date === null) return null

  const time = parseBannerTime(timeValue)

  if (time === null) return null
  if (!time) return isEndDate ? endOfDay(date) : date

  const dateTime = set(date, {
    hours: time.getHours(),
    minutes: time.getMinutes(),
    seconds: 0,
    milliseconds: 0,
  })

  return isEndDate ? endOfMinute(dateTime) : dateTime
}

const isBannerInTerm = (banner, currentDate = new Date()) => {
  const start = getBannerDateTime(banner.dateStart, banner.timeStart)
  const end = getBannerDateTime(banner.dateEnd, banner.timeEnd, true)

  if (start === null || end === null) return false
  if (start && isBefore(currentDate, start)) return false
  if (end && isAfter(currentDate, end)) return false

  return true
}

const isBannerAvailable = (banner) =>
  Boolean(banner.isActive) && (!banner.isTerm || isBannerInTerm(banner))

const getAvailableBanners = (banners) =>
  orderBy(Array.isArray(banners) ? banners : [], ['pos'], ['asc'])
    .map((banner) => ({
      ...banner,
      isActive: isBannerAvailable(banner),
    }))
    .filter((banner) => banner.isActive)

export default getAvailableBanners
